import { render, staticRenderFns } from "./UserImport.vue?vue&type=template&id=3c85ab1f"
import script from "./UserImport.vue?vue&type=script&lang=ts"
export * from "./UserImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports